import { render } from "./WazzupSettingsModal.vue?vue&type=template&id=cf54b41e"
import script from "./WazzupSettingsModal.vue?vue&type=script&lang=js"
export * from "./WazzupSettingsModal.vue?vue&type=script&lang=js"
script.render = render

export default script